import iosPWASplash from "@/lib/ios-pwa-splash";
import { useConfigStore } from "@/store/use-config-store";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export default function IosSplashScreen() {
  const [selfUrl] = useConfigStore(useShallow((state) => [state?.settings?.selfUrl]));

  useEffect(() => {
    if (!selfUrl) return;

    const isProduction = process.env.NODE_ENV === "production";
    const staticBase = isProduction
      ? "/ee-static/membersapp"
      : "/membersapp/ee-static/membersapp";
    const origin = isProduction ? new URL(selfUrl).origin : window.location.origin;
    const iconUrl = `${origin}${staticBase}/icons/icon-512x512.png`;

    (async () => {
      try {
        const res = await fetch(`${origin}${staticBase}/manifest.json`);
        const manifest = res.ok ? await res.json() : null;
        iosPWASplash(iconUrl, manifest?.background_color ?? "#ffffff");
      } catch (error) {
        console.warn("Failed to initialize iOS PWA splash screen", error);
      }
    })();
  }, [selfUrl]);

  return null;
}
